import { render, staticRenderFns } from "./AddGraduateModal.vue?vue&type=template&id=497e6573&"
import script from "./AddGraduateModal.vue?vue&type=script&lang=js&"
export * from "./AddGraduateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports